import React, { useEffect, useState } from 'react';
import {
  Form,
  Formik
} from 'formik';
import { useRecoilValue } from 'recoil';
import { useLocation, useOutletContext } from 'react-router-dom';
import { businessList, useIsMobile, fundingDetailsState, applicationsList } from '../../../recoil';
import { findFirstValidationError } from '../../../helpers/formik';
import { useTealium } from '../../../tealium/useTealium';
import { FormSubmitHelper } from '../../../components';
import { ThemeProvider, THEME } from '@vodacomsa/ns-react-components';
import { FormBuilder } from '../../../components/FormBuilder';
import { formFields } from './BusinessListConstants';
import { ApplicationRoutes } from '../../../Router';
import { useLoader } from '../../../components/Loader/useLoader';
import { appStatuses } from '../../../constants';

export const BusinessList = () => {
  const storedBusinessId = localStorage.getItem('businessId');
  const [businessId, setBusinessId] = useState(storedBusinessId || undefined);
  const { submitState, setSubmitState, backClick, submissionStates, nextClick } = useOutletContext();
  const [openLoader, closeLoader] = useLoader();
  const location = useLocation();
  const isMobile = useRecoilValue(useIsMobile);
  const fundingDetails = useRecoilValue(fundingDetailsState);
  const appsList = useRecoilValue(applicationsList);
  const bussinessList = useRecoilValue(businessList);
  const [radiogroupOptionsList, setRadiogroupOptionsList] = useState(bussinessList);
  const formRef = React.useRef();
  const { track, events } = useTealium();
  const [isNewBusiness, setIsNewBusiness] = useState(false);
  const formStartedRef = React.useRef(false);

  const handleFormikTouchedErrors = (touched, errors) => {
    const errorMessage = findFirstValidationError(errors, touched);

    if (!errorMessage) {
      return;
    }
    track(events.error('form', location.pathname, errorMessage));
  };

  useEffect(() => {
    const updatedBusinessList = formatBusinessList(radiogroupOptionsList);
    setRadiogroupOptionsList({businesses: updatedBusinessList});
    setSubmitState(submissionStates.canSubmit);
    track(events.businessList.pageView());
  }, []);

  // useEffect(() => {
  //   localStorage.setItem('isNewBusiness', isNewBusiness);
  // }, [isNewBusiness]);

  const handleFormFocus = () => {
    if (formStartedRef.current) {
      return;
    }
    formStartedRef.current = true;
    track(events.businessList.formStart());
  };

  const handleRadioGroupChange = (selectedValue) => {
    if (selectedValue) {
      setBusinessId(selectedValue);
      setIsNewBusiness(false);
      const options = formatBusinessList(bussinessList);
      const selectedOption = options?.find((opt) => opt.value === selectedValue);
      track(events.businessList.selection(false, selectedOption?.label));
    } else {
      localStorage.removeItem('businessId');
      setBusinessId(undefined); // Ensure businessId is undefined so nextClick is blocked if needed
      setIsNewBusiness(true);
      track(events.businessList.selection(true));
    }
    setSubmitState(submissionStates.canSubmit);
  };

  const formatBusinessList = (businessList) => {
    const businesses=[];

    const selectedPartnerCode = fundingDetails?.partnerCode;
    businessList?.businesses?.forEach(business => {
      const isSameProduct = appsList.some( app =>
        app.partnerCode === selectedPartnerCode &&
        business.businessId === app.businessId &&
        (app.applicationStatus !== appStatuses.Closed && app.applicationStatus !== appStatuses.Declined)
      );
      const isSameBusiness = business.businessType === fundingDetails.businessType;
      const businessObj = {
        label: business.businessName,
        value: business.businessId,
        isSameBusiness,
        isSameProduct,
        productName: fundingDetails?.productName,
        businessType: business.businessType
      };
      businesses.push(businessObj);
    });
    businesses.push({label: 'I have a new business', value: ''});
    return businesses;
  };

  const handleSubmit = () => {
    if(!isNewBusiness) {
      localStorage.setItem('businessId', businessId);
    }
  };

  const handleNext = async () => {
    openLoader();
    track(events.businessList.formEnd('next'));
    if (isNewBusiness) {
      localStorage.removeItem('businessId');
      sessionStorage.removeItem('vatNumber');
      window.location.pathname = ApplicationRoutes.businessVerification;
    } else {
      window.location.pathname = ApplicationRoutes.businessDetails;
    }
    closeLoader();
    nextClick();
  };

  const handleBack = () => {
    track(events.businessList.formEnd('back'));
    backClick();
  };

  return(
    <div>
      <ThemeProvider theme={THEME.revamp} >
        <Formik
          initialValues={{}}
          onSubmit={handleSubmit}
          innerRef={formRef}
        >
          {({ values, errors, touched }) => {
            handleFormikTouchedErrors(touched, errors);
            return( <div>
              <Form onFocus={handleFormFocus} >
                <FormSubmitHelper submitState={submitState} setSubmitState={setSubmitState} />
                <FormBuilder
                  fields={formFields}
                  title="We’ve picked up your existing business(es)"
                  subtitle="Select which business you would like to use"
                  values={values}
                  radioGroupOptions={formatBusinessList(bussinessList)}
                  errors={errors}
                  isMobile={isMobile}
                  backClick={handleBack}
                  radioGroupDefaultValue={storedBusinessId || ''}
                  submissionStates={submissionStates}
                  submitState={submitState}
                  selectedBusiness = {businessId}
                  pageName = 'businessList'
                  isNewBusiness = {isNewBusiness}
                  setSubmitState={setSubmitState}
                  businessList={radiogroupOptionsList}
                  handleRadioGroupChange={(e) => handleRadioGroupChange(e)}
                  nextClick={isNewBusiness || businessId !== undefined ? handleNext : ''}
                  touched={touched}
                />
              </Form>
            </div>);
          }}
        </Formik>
      </ThemeProvider>
    </div>);
};
